/**
 * Default configuration values for FlowLight
 */

export const DEFAULT_OPTIONS = {
  debug: false,
  buttonSize: 60,
  buttonPosition: { bottom: 20, right: 20 },
  zIndex: 9999,
  searchDebounceDelay: 500,
  autoDismissDelay: 3500,
  inputIdleDelay: 500,
  errorDisplayDuration: 3000,
  keyboardShortcuts: true
};

export const SUGGESTIONS = [
  "How do I use this feature?",
  "What are the keyboard shortcuts?",
  "Show me the documentation",
  "How to customize the interface?",
  "What are the available options?",
  "Help me get started",
  "Troubleshooting guide",
  "API reference",
  "Examples and demos",
  "Contact support"
];

export const COOKIE_NAMES = {
  flowPoints: "flowlight_flow_points",
  flowCurrentIdx: "flowlight_flow_current_idx"
};

import { ENV_CONFIG } from '../../env.config.js';

export const API_ENDPOINTS = ENV_CONFIG.apiEndpoints;

export const PROJECT_ID = "proj_bTs8cbhOyBLgcjzQ2qNQgQ";

export const SEARCH_CONFIG = {
  limit: 3,
  minQueryLength: 2
}; 